import type { OutlineState } from '../types.js';

export function createOutlineState(): OutlineState {
  return {
    files: [],
    activeFileId: null,
    nodes: new Map(),
    children: new Map(),
    rootIds: [],
    activeNodeId: null,
  };
}

function childKey(parentId) {
  return parentId === null ? 'root' : String(parentId);
}

export function rebuildOutlineState(state, nodes) {
  state.nodes = new Map();
  state.children = new Map();
  state.rootIds = [];

  for (const node of nodes || []) {
    state.nodes.set(node.id, node);
    const key = childKey(node.parent_id);
    if (!state.children.has(key)) {
      state.children.set(key, []);
    }
    state.children.get(key).push(node.id);
  }

  for (const ids of state.children.values()) {
    ids.sort((a, b) => {
      const nodeA = state.nodes.get(a);
      const nodeB = state.nodes.get(b);
      return nodeA.position - nodeB.position || nodeA.id - nodeB.id;
    });
  }

  state.rootIds = state.children.get('root') || [];
}

export function getOutlineChildren(state, parentId) {
  return state.children.get(childKey(parentId)) || [];
}
